function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_news_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M63.979 56.657h155.905v28.346H63.979zM63.979 113.386h99.213v28.346H63.979z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.068 28.415v155.899H138.583l-46.495 38.82v-38.82H28.296v-155.8h226.772M283.465 0H0v212.928h63.792v70.537l84.99-70.536h134.583V-.001h.1z"
})));